
import { createRouter, createWebHashHistory } from 'vue-router';



const routes = [

  {
    path: "/login",
    name: "loginView",
    component: () => import("@/views/login/loginView.vue"),
  },
  {
    path: "/forget",
    name: "forgetPwd",
    component: () => import("@/views/login/forgetPwd.vue"),
  },
  {
    path: "/",
    name: "homeView",
    component: () => import("@/views/homeView.vue"),
  },
  {
    path: "/ai",
    name: "aiView",
    component: () => import("@/views/ai/aiView.vue"),
  },
  {
    path: "/ai/upload",
    name: "knowledgeUploadView",
    component: () => import("@/views/ai/knowledgeUploadView.vue"),
  },
  {
    path: "/message_list",
    name: "messageList",
    component: () => import("@/views/messageList.vue"),
  },
  {
    path: "/knowledge",
    name: "knowledgeView",
    component: () => import("@/views/knowledge/knowledgeView.vue"),
  },
  {
    path: "/knowledge/list",
    name: "listView",
    component: () => import("@/views/knowledge/listView.vue"),
  },
  {
    path: "/knowledge/detail",
    name: "newsInfo",
    component: () => import("@/views/knowledge/detailView.vue"),
  },
  {
    path: "/process",
    name: "processAdd",
    component: () => import("@/views/process/processAdd.vue"),
  }, {
    path: "/process/todolist",
    name: "todoList",
    component: () => import("@/views/process/todoList.vue"),
  }, {
    path: "/process/completed",
    name: "completedMatters",
    component: () => import("@/views/process/completedMatters.vue"),
  }, {
    path: "/process/finish",
    name: "finishMatters",
    component: () => import("@/views/process/finishMatters.vue"),
  }, {
    path: "/process/initiate",
    name: "InitiatingEvent",
    component: () => import("@/views/process/InitiatingEvent.vue"),
  }, {
    path: "/process/applicant",
    name: "applicantView",
    component: () => import("@/views/process/applicantView.vue"),
  }, {
    path: "/process/receiving",
    name: "receivingDocuments",
    component: () => import("@/views/process/receivingDocuments.vue"),
  }, {
    path: "/process/handledBy",
    name: "handledBy",
    component: () => import("@/views/process/handledBy.vue"),
  }, {
    path: "/process/promoter",
    name: "promoterView",
    component: () => import("@/views/process/promoterView.vue"),
  }
  //个人中心
  , {
    path: "/user",
    name: "userInfo",
    component: () => import("@/views/member/userInfo.vue"),
  }
  , {
    path: "/user/addressList",
    name: "addressList",
    component: () => import("@/views/member/addressList.vue"),
  }
  , {
    path: "/user/message",
    name: "message",
    component: () => import("@/views/member/message.vue"),
  }
  //新闻中心
  , {
    path: "/news",
    name: "newsList",
    component: () => import("@/views/news/newsList.vue"),
  }, {
    path: "/news/add",
    name: "newsAdd",
    component: () => import("@/views/news/newsAdd.vue"),
  }
  //文档中心
  , {
    path: "/document",
    name: "documentList",
    component: () => import("@/views/document/documentList.vue"),
  }, {
    path: "/document/add",
    name: "add",
    component: () => import("@/views/document/documentAdd.vue"),
  }, {
    path: "/result",
    name: "publisheView",
    component: () => import("@/views/publisheView.vue"),
  }
];

const router = createRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  history: createWebHashHistory(),
  routes,
});

export default router;
